import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgUnloggedIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "currentColor",
	viewBox: "0 0 15 15",
	...props,
	children: [/* @__PURE__ */ _jsx("g", {
		clipPath: "url(#a)",
		children: /* @__PURE__ */ _jsx("path", { d: "M0 2.813C0 1.778.84.937 1.875.937h11.25C14.159.938 15 1.778 15 2.813v9.376c0 1.034-.84 1.874-1.875 1.874H1.875A1.877 1.877 0 0 1 0 12.188V2.812Zm1.875 0v1.874H3.75V2.813H1.875Zm11.25 0h-7.5v1.874h7.5V2.813Zm-11.25 3.75v1.875H3.75V6.562H1.875Zm11.25 0h-7.5v1.875h7.5V6.562Zm-11.25 3.75v1.874H3.75v-1.874H1.875Zm11.25 0h-7.5v1.874h7.5v-1.874Z" })
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "a",
		children: /* @__PURE__ */ _jsx("path", {
			fill: "#fff",
			d: "M0 0h15v15H0z"
		})
	}) })]
});
export default SvgUnloggedIcon;
